
import axios from "axios";
//import authHeader from '@/auth/auth-header';
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';

let config = {
  baseURL: process.env.VUE_APP_ROOT_API || 'http://localhost:8082/publicacao/api',
};

const http = axios.create(config);

http.interceptors.request.use(function (config) {

  let user = JSON.parse(localStorage.getItem('user'));
  /* console.log('token '+ user.accessToken)  */
  if (user) {
    config.headers.Authorization = `Bearer ${user.accessToken}`;
  }
  return config;
},
  erro => Promise.reject(erro)
);

export { http }